import React, { useEffect, useState, Fragment } from "react";
import { Link, withPrefix } from "gatsby";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PlainPage from "../../templates/plain-page";
import { getInvitedUsers, getVerifierName } from "../../components/auth/Auth";
import { db, firebaseFunc } from "../../components/firebase/firestore";
import Modal from "../../components/Modal";
import steps from "../../../static/img/imgpsh_fullsize_anim.jpg";
import rank1 from "../../../static/img/rank_1.png";
import rank2 from "../../../static/img/rank_2.png";
import rank3 from "../../../static/img/rank_3.png";
import rank4 from "../../../static/img/rank_4.png";
import rank5 from "../../../static/img/rank_5.png";
import {
  formatDate,
  copyToClipboard,
  useInterval,
  convertHashtagsToURLFormat,
} from "../../utils/utils";
import Avatar from "../../components/user/Avatar";
import BlogLatest from "../../components/BlogLatest";

// section above should be in sync with server code
// start server section
const POINTS_FOR_SIGNUP = 100;
const DAYS_PER_ITERATION = 4;
const ITERATIONS_COUNT = 3;
const MAX_ALLOWED_FAILS = 1;
const MAX_INVITEES_PER_ITERATION = [0, 20, 30, 50]; // first element must be 0 as iterations start from 1
const POINTS_PER_INVITEE = 50;
const TOTAL_POINTS =
  POINTS_PER_INVITEE *
    MAX_INVITEES_PER_ITERATION.reduce(
      (totalInv, iterInv) => totalInv + iterInv,
    ) +
  POINTS_FOR_SIGNUP;
const MS_IN_DAY = 24 * 60 * 60 * 1000;
const MS_IN_HOUR = 60 * 60 * 1000;
const MS_IN_MIN = 60 * 1000;
const RANK = [4951, 3751, 2501, 1251];

// end server section

const getEmailShareText = (origin, uid, multiline = false) =>
  `OCCASIO is an ambitious and exciting project that aims to connect businesses, workers, entrepreneurs and investors in Africa and the diaspora. The project is at stage one and a select group of people are being invited to join as early-stage advocates to grow the network organically. In return, early-stage advocates will be able to earn points redeemable against rewards on launch. The earlier we join, the more points and benefits we earn. I am one of the lucky few who have been chosen and I would like to invite you. I have just a few invites left and the link will no longer work once the spaces are gone. Signing up is fast, free, safe and secure. Here is my invite link: ${origin}${withPrefix(
    "/ref",
  )}/?u=${uid}${
    multiline ? "%0A%0A" : " "
  }Let me know once you are registered because I will need to verify you before you can be a fully-fledged member. Once you are verified, you can earn network rewards by doing as I am doing and inviting connections to the network.`;

const getFbShareText = (origin, uid, addLink = true) =>
  `OCCASIO is an ambitious project that aims to connect businesses, workers, entrepreneurs and investors in Africa and the diaspora. The project is at stage one and a select group of people are being invited to join as early-stage advocates to grow the network organically. In return, early-stage advocates will be able to earn points redeemable against rewards on launch. The earlier we join, the more points and benefits we earn. I am one of the lucky few who have been chosen and I would like to invite you. I have just a few invites left and the link will no longer work once the spaces are gone. Signing up is fast, free, safe and secure. Here is my invite link${
    addLink ? ` :${origin}${withPrefix("/ref")}/?u=${uid}` : "."
  } Let me know once you are registered because I will need to confirm you before you can be fully-fledged. ${
    addLink
      ? "#onOCCASIO #OnOCCASOInvite #onOCCASIOReferral #onOCCASIOOnline #onOCCASIONetwork #AfricanNetwork #InvestInAfrica #Business #Investment #Jobs #Careers #Training #Students #Interns #ProfessionalDevelopment #PersonalDevelopment #Mentoring #Coaching #Promotion #WestAfrica #EastAfrica #SouthAfrica #NorthAfrica #Networking #Internships"
      : ""
  }`;

// const getFbShareText = (origin, uid) =>
//   `OCCASIO is an ambitious project that aims to connect businesses, workers, entrepreneurs and investors in Africa and the diaspora. The project is at stage one and a select group of people are being invited to join as early-stage advocates to grow the network organically. In return, early-stage advocates will be able to earn points redeemable against rewards on launch. The earlier we join, the more points and benefits we earn. I am one of the lucky few who have been chosen and I would like to invite you. I have just a few invites left and the link will no longer work once the spaces are gone. Signing up is fast, free, safe and secure. Here is my invite link:${origin}${withPrefix(
//     "/ref",
//   )}/?u=${uid} Let me know once you are registered because I will need to confirm you before you can be fully-fledged. #onOCCASIO #OnOCCASOInvite #onOCCASIOReferral #onOCCASIOOnline #onOCCASIONetwork #OCCASIO #AfricanNetwork #InvestInAfrica #Business #Investment #Jobs #Careers #Training #Students #Interns #ProfessionalDevelopment #PersonalDevelopment #Mentoring #Coaching #Promotion #WestAfrica #EastAfrica #SouthAfrica #NorthAfrica #Networking #Internships`;

const getSkypeShareText = (origin, uid) =>
  `OCCASIO is an ambitious project that aims to connect businesses, workers, entrepreneurs and investors in Africa. The project is at stage one and a select group of people are being invited to join as early-stage advocates to grow the network organically. In return, early-stage advocates will be able to earn points redeemable against rewards on launch. The earlier we join, the more points and benefits we earn. I am one of the lucky few who have been chosen and I would like to invite you. I have just a few invites left and the link will no longer work once the spaces are gone. Signing up is fast, free, safe and secure. Here is my invite link: ${origin}${withPrefix(
    "/ref",
  )}/?u=${uid}`;

const getTwtrShareText = (origin, uid) =>
  `@onOccasio is an invite-only network connecting businesses, workers, entrepreneurs and investors in Africa in the diaspora. Limited invites left to join the network. Use link: ${origin}${withPrefix(
    "/ref",
  )}/?u=${uid}`;

// TODO calc this and status only once after each change
export const getIteration = data => {
  const date = new Date().getTime();
  // eslint-disable-next-line no-plusplus
  for (let index = 1; index <= ITERATIONS_COUNT; index++) {
    if (date < data[`iteration_${index}_end_date`]) {
      return index;
    }
  }
  return ITERATIONS_COUNT + 1;
};

export const getStatus = data => {
  const iteration = getIteration(data);
  let timesFailed = 0;

  // eslint-disable-next-line no-plusplus
  for (let index = 1; index < iteration; index++) {
    if (data[`iteration_${index}_invitees`]) {
      timesFailed +=
        data[`iteration_${index}_invitees`].length <
        MAX_INVITEES_PER_ITERATION[index]
          ? 1
          : 0;
    } else {
      timesFailed += 1;
    }
  }

  if (timesFailed > MAX_ALLOWED_FAILS) {
    return "failed";
  }

  if (iteration > ITERATIONS_COUNT) {
    return "succeed";
  }

  return "active";
};

const getRank = points => {
  if (points >= RANK[0]) {
    return "Top 1%";
  }
  if (points >= RANK[1]) {
    return "High Performance";
  }
  if (points >= RANK[2]) {
    return "Trail Blazer";
  }
  if (points >= RANK[3]) {
    return "Tortoise";
  }
  return "Snooze Mode";
};

const getRankNumber = points => {
  if (points >= RANK[0]) {
    return 1;
  }
  if (points >= RANK[1]) {
    return 2;
  }
  if (points >= RANK[2]) {
    return 3;
  }
  if (points >= RANK[3]) {
    return 4;
  }
  return 5;
};

const getIterationLabel = (iteration, invitees, currentIteration, status) => {
  let iterEnding;
  switch (iteration) {
    // TODO make universal
    case 1:
      iterEnding = "st";
      break;
    case 2:
      iterEnding = "nd";
      break;
    case 3:
      iterEnding = "rd";
      break;
    default:
      iterEnding = "th";
  }

  if (iteration <= currentIteration) {
    return (
      <>
        <span className="has-text-grey">
          <span className="has-text-weight-bold">
            <span className="is-size-5">{iteration}</span>
            {iterEnding}
          </span>{" "}
          round
        </span>{" "}
        <br />
        <span className="is-size-4 has-text-weight-bold">
          {invitees.length * POINTS_PER_INVITEE}
        </span>{" "}
        points for{" "}
        <span className="is-size-4 has-text-weight-medium">
          {invitees.length}
        </span>{" "}
        successful verifications out of a possible{" "}
        <span className="is-size-6 has-text-weight-medium">
          {MAX_INVITEES_PER_ITERATION[iteration]}
        </span>
        <br />
        <br />
      </>
    );
  }
  return "";
};

const RankImg = ({ img, title, num, points }) => (
  <p
    className="field-value  "
    style={{
      paddingTop: "0.5rem",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    <img
      src={img}
      style={
        getRankNumber(points.points) === num
          ? {
              width: "48px",
            }
          : {
              width: "48px",
              opacity: 0.5,
            }
      }
      alt="rank"
    />
    <span
      className={`has-text-centered is-size-7 m-t-xs nowrap ${getRankNumber(
        points.points,
      ) === num && "has-text-success has-text-weight-bold text-glow"}`}
    >
      {title}
    </span>
  </p>
);

const UserList = ({ users, currentUserUid, verify, reject }) => {
  const filteredUsers = users.filter(
    user => !user.isVerified && !user.isRejected,
  );
  return filteredUsers.length
    ? filteredUsers.map(user => (
        <div className="box" key={user.uid}>
          <div className="columns is-mobile">
            <div className="column align-line-btn p-l-sm has-text-left">
              <Avatar id={user.uid} className="image-userlist" />
              <span
                style={{
                  marginLeft: "2.4rem",
                }}
              >
                <b>{user.name}</b>&emsp;
                <span className="nowrap">{user.signUpDate}</span>
              </span>
            </div>

            <div
              className="column has-text-right nowrap is-narrow"
              style={{ paddingLeft: "0" }}
            >
              <Fragment>
                <button
                  id={`verify-${user.uid}`}
                  type="button"
                  className="button is-success"
                  onClick={verify(currentUserUid, user.uid)}
                >
                  Verify
                </button>
                <button
                  id={`reject-${user.uid}`}
                  type="button"
                  className="button is-danger m-l-md"
                  onClick={reject(currentUserUid, user.uid)}
                >
                  Reject
                </button>
              </Fragment>
            </div>
          </div>
        </div>
      ))
    : "You have no more connections to review.";
};

const VerifiedUserList = ({ users }) => {
  const filteredUsers = users.filter(user => user.isVerified);
  return filteredUsers.length
    ? filteredUsers.map(user => (
        <div className="box" key={user.uid}>
          <div className="columns is-mobile">
            <div className="column align-line-btn p-l-sm has-text-left">
              <Avatar id={user.uid} className="image-userlist" />
              <span
                style={{
                  marginLeft: "2.4rem",
                }}
              >
                <b>{user.name}</b>&emsp;
                <span className="nowrap">{user.signUpDate}</span>
              </span>
            </div>

            <div className="column has-text-right nowrap is-narrow">
              <button type="button" className="button is-static-success m-l-md">
                Verified
              </button>
            </div>
          </div>
        </div>
      ))
    : "The list is empty.";
};

const RejectedUserList = ({ users }) => {
  const filteredUsers = users.filter(user => user.isRejected);
  return filteredUsers.length
    ? filteredUsers.map(user => (
        <div className="box" key={user.uid}>
          <div className="columns is-mobile">
            <div className="column align-line-btn p-l-sm has-text-left">
              <Avatar id={user.uid} className="image-userlist" />
              <span
                style={{
                  marginLeft: "2.4rem",
                }}
              >
                <b>{user.name}</b>&emsp;
                <span className="nowrap">{user.signUpDate}</span>
              </span>
            </div>

            <div className="column has-text-right nowrap is-narrow">
              <button type="button" className="button is-static-danger m-l-md">
                Rejected
              </button>
            </div>
          </div>
        </div>
      ))
    : "The list is empty.";
};

const Countdown = ({ msTotal }) => {
  if (msTotal === null) {
    return "—";
  }

  if (msTotal <= MS_IN_MIN) {
    return "less than 1M";
  }

  const days = Math.floor(msTotal / MS_IN_DAY);
  const hours = Math.floor((msTotal - MS_IN_DAY * days) / MS_IN_HOUR);
  const min = Math.floor(
    (msTotal - MS_IN_DAY * days - hours * MS_IN_HOUR) / MS_IN_MIN,
  );
  return (
    <Fragment>
      {days !== 0 && (
        <Fragment>
          {days}D <span className="blink">:</span>{" "}
        </Fragment>
      )}
      {hours !== 0 && (
        <Fragment>
          {hours}H <span className="blink">:</span>{" "}
        </Fragment>
      )}
      {min}M
    </Fragment>
  );
};

const getCurrentIterPoints = points => {
  return points[`iteration_${getIteration(points)}_invitees`]
    ? points[`iteration_${getIteration(points)}_invitees`].length *
        POINTS_PER_INVITEE
    : 0;
};

const Content = location => ({ currentUser, reduceNotVerifiedUsersCount }) => {
  const [users, setUsers] = useState([]);
  // const [refUsers, setRefUsers] = useState();
  // const [userPoints, setUserPoints] = useState();
  const [firstName, setFirstName] = useState("");

  const [inviteTemplatesOpen, setInviteTemplatesOpen] = useState(false);
  const [inviteTemplatesCb, setInviteTemplatesCb] = useState({
    submit: () => {},
    deny: () => {
      setInviteTemplatesOpen(false);
    },
  });

  const [pointsModalOpen, setPointsModalOpen] = useState(false);
  const [pointsModalCb, setPointsModalCb] = useState({
    submit: () => {},
    deny: () => {
      setPointsModalOpen(false);
    },
  });

  // TODO remove
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  // TODO make null
  const [points, setPoints] = useState({
    points: 0,
    iteration_1_invitees: [],
    iteration_2_invitees: [],
    iteration_3_invitees: [],
    iteration_1_start_date: new Date().getTime(),
    iteration_1_end_date: addDays(new Date(), DAYS_PER_ITERATION).getTime(),
    iteration_2_start_date: addDays(new Date(), DAYS_PER_ITERATION).getTime(),
    iteration_2_end_date: addDays(new Date(), DAYS_PER_ITERATION * 2).getTime(),
    iteration_3_start_date: addDays(
      new Date(),
      DAYS_PER_ITERATION * 2,
    ).getTime(),
    iteration_3_end_date: addDays(new Date(), DAYS_PER_ITERATION * 3).getTime(),
  });

  const [currentDate, setCurrentDate] = useState(new Date());
  const [timeLeft, setTimeLeft] = useState(null);
  const [verifier, setVerifier] = useState();
  const [signupDate, setSignupDate] = useState();

  // TODO delete
  // useEffect(() => {}, [users]);

  const tick = pointsRef => {
    const iter = getIteration(pointsRef);
    const status = getStatus(pointsRef);

    if (status === "active" && iter <= ITERATIONS_COUNT) {
      setTimeLeft(
        Math.max(
          pointsRef[`iteration_${iter}_end_date`] - new Date().getTime(),
          0,
        ),
      );
    } else {
      setTimeLeft(null);
    }
    setPoints({ ...pointsRef });
  };

  useInterval(() => {
    tick(points);
  }, 60000);

  useEffect(() => {
    if (currentUser) {
      getInvitedUsers(currentUser.uid).then(u => {
        setUsers(u);
      });
      // ref users count
      // getInvitedUsersCount(currentUser.uid).then(data => {
      //   setRefUsers(data);
      // });
      // get user points
      const ref = db.collection("points").doc(currentUser.uid);
      ref.get().then(doc => {
        if (doc.exists) {
          tick(doc.data());
        } else {
          // old users, who don't have Points document
          const triggerUserInit = firebaseFunc.httpsCallable("triggerUserInit");
          triggerUserInit().then(() => {
            ref.get().then(doc2 => {
              if (doc2.exists) {
                tick(doc2.data());
              }
            });
          });
        }
      });

      // get user name
      const userRef = db.collection("users").doc(currentUser.uid);
      userRef.get().then(doc => {
        if (doc.exists) {
          setFirstName(doc.data().first_name);
        }
      });

      // Verification status
      getVerifierName(currentUser.uid).then(name => setVerifier(name));

      // Signup date
      // don't get from users/uid/signUpDate to save on queries
      setSignupDate(formatDate(new Date(currentUser.metadata.creationTime)));
    }
  }, [currentUser]);

  const verify = (currentUserUid, uid) => () => {
    const button = document.getElementById(`verify-${uid}`);
    button.classList.add("is-loading");

    const ref = db.collection("verification").doc(uid);
    ref
      .get()
      .then(doc => {
        if (!doc.exists) {
          ref.set({ status: "verified", changer_uid: currentUserUid });
          reduceNotVerifiedUsersCount();

          const iteration = getIteration(points);
          const user = users[users.findIndex(u => u.uid === uid)];
          user.isVerified = true;
          // TODO useReducer may be a faster solution
          setUsers([...users]);

          if (
            iteration <= ITERATIONS_COUNT &&
            points[`iteration_${iteration}_invitees`].length <
              MAX_INVITEES_PER_ITERATION[iteration]
          ) {
            points[`iteration_${iteration}_invitees`].push(uid);
          }
          points.points =
            (points.iteration_1_invitees.length +
              points.iteration_2_invitees.length +
              points.iteration_3_invitees.length) *
              POINTS_PER_INVITEE +
            POINTS_FOR_SIGNUP;
          setPoints({ ...points });
        }
      })
      .catch(e => alert(e))
      .finally(() => {
        button.classList.remove("is-loading");
      });
  };

  const reject = (currentUserUid, uid) => () => {
    const button = document.getElementById(`reject-${uid}`);
    button.classList.add("is-loading");

    const ref = db.collection("verification").doc(uid);
    ref
      .get()
      .then(doc => {
        if (!doc.exists) {
          ref.set({ status: "rejected", changer_uid: currentUserUid });
          reduceNotVerifiedUsersCount();

          const user = users[users.findIndex(u => u.uid === uid)];
          user.isRejected = true;
          setUsers([...users]);
        }
      })
      .catch(e => alert(e))
      .finally(() => {
        button.classList.remove("is-loading");
      });
  };

  const getSummaryText = () => {
    if (getStatus(points) === "succeed") {
      return `You have collected ${points.points} points out of a possible ${TOTAL_POINTS}. Although your window for collecting points is over, you can still invite and verify your contacts. Verifying your connections allows you to continue to grow your influence on the platform and enables your friends to earn points.`;
    }
    if (getStatus(points) === "failed") {
      return `You have collected ${points.points} points out of a possible ${TOTAL_POINTS}! Although your window for earning points is now over, you can still invite and verify contacts to continue to grow your influence on the platform and enable your friends to earn points.`;
    }
    const iteration = getIteration(points);
    if (iteration === 1) {
      return (
        <span>
          How connected are you? Grow your influence on the network and earn
          points by inviting your contacts. You have {DAYS_PER_ITERATION} days
          to invite and verify {MAX_INVITEES_PER_ITERATION[iteration]} contacts
          to earn {POINTS_PER_INVITEE * MAX_INVITEES_PER_ITERATION[iteration]}{" "}
          points. See the tools available in the{" "}
          <a href="#spread">Grow your network</a> section below to start sharing
          your referral code via email and social media. Best of luck!
        </span>
      );
    }
    if (iteration === 2) {
      return `You collected ${
        points.points
      } points! You now have a chance to double-down and grow you influence and earn even more points! Still believe in your network? Start sharing your referral code. You have ${DAYS_PER_ITERATION} days to invite and verify ${
        MAX_INVITEES_PER_ITERATION[iteration]
      } contacts and earn ${POINTS_PER_INVITEE *
        MAX_INVITEES_PER_ITERATION[
          iteration
        ]} points for a full-house. Best of luck!`;
    }
    if (iteration === 3) {
      return `You have collected a total of ${
        points.points
      } of a possible ${TOTAL_POINTS} points, which makes you a ${getRank(
        points.points,
      )}. Well done! How about one last chance to bring it home? We are giving you an extra ${DAYS_PER_ITERATION} days to invite and verify ${
        MAX_INVITEES_PER_ITERATION[iteration]
      } contacts and earn a bonus ${POINTS_PER_INVITEE *
        MAX_INVITEES_PER_ITERATION[
          iteration
        ]} points for that strong finish! Started sharing your referral link now. Best of luck!`;
    }
    return "";
  };

  return (
    <div className="column is-12 is-10-fullhd is-offset-1-fullhd">
      {/* <h4 className="title is-size-5 has-text-weight-bold is-bold-light">
        <Link to="/settings">&larr; go back to settings</Link>
      </h4> */}
      <h2 className="title is-size-3 has-text-weight-bold is-bold-light m-b-sm">
        {firstName}!
      </h2>
      <p className="is-size-6 m-b-md">{getSummaryText()}</p>
      {/* {refUsers ? (
        <p className="title is-size-6 is-pill-dark">
          {refUsers.totalCount} Users Registered&nbsp;&nbsp;|&nbsp;&nbsp;
          {refUsers.notVerifiedCount} Awaiting
          Verification&nbsp;&nbsp;|&nbsp;&nbsp;
          {refUsers.totalCount - refUsers.notVerifiedCount}{" "}
          Verified&nbsp;&nbsp;|&nbsp;&nbsp;* Rejected
        </p>
      ) : (
        ""
      )} */}
      {/* <div className="columns is-desktop">
        <div className="column is-12-desktop is-6-widescreen">
          <p className="title is-size-6 is-pill-dark" style={{ width: "100%" }}>
            {users.length}&nbsp;&nbsp;Registered&emsp;|&emsp;
            {users.filter(user => !user.isVerified && !user.isRejected).length}
            &nbsp;&nbsp;Pending&nbsp;Review&emsp;|&emsp;
            {users.filter(user => user.isVerified).length}
            &nbsp;&nbsp;Verified&emsp;|&emsp;
            {users.filter(user => user.isRejected).length}&nbsp;&nbsp;Rejected
          </p>
        </div>
      </div> */}
      {/* <div className="columns is-desktop">
        <div className="column is-12-desktop is-6-widescreen">
<div className=" panel-block has-background-grey-darker has-text-white-ter m-b-md" style={{borderRadius: "4px"}} >
            <span className="control">
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <div className="control">
                      <p className="field-value is-size-4 has-text-weight-bold  p-t-none">
                        0
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Registered
                    </label>
                  </div>
                </div>
                <div className="column">
                  <div className="field">
                    <div className="control">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        0
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      For Review
                    </label>
                  </div>
                </div>
                <div className="column">
                  <div className="field">
                    <div className="control">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        0
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Verified
                    </label>
                  </div>
                </div>
                <div className="column">
                  <div className="field">
                    <div className="control">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        0
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Rejected
                    </label>
                  </div>
                </div>
              </div>
            </span>
          </div></div>
      </div> */}

      {/* <div className="columns is-desktop">
        <div className="column ">
          <p className="content">
            OCCASIO is a trusted network of connected people and so to keep it a
            safe place, we have a real data policy which means users must use
            real names, real information and hold a single account. We also ask
            our users to verify their connections to retain the integrity of the
            network. We carry out periodic checks and accounts with duplicate or
            inaccurate information that breach our conditions will be terminated
            and banned without notice. This page is provided for you to review
            and approve or reject people who have used your referral link to
            join the network. Please only verify connections that you recognise
            once. If you find multiple registrations by someone you know,
            approve one registration and reject the other. If you find a
            registrations by someone you do not know, reject the registration.
          </p>
        </div>
      </div> */}
      <div className="columns is-desktop">
        <div className="column is-mobile is-6-desktop is-6-widescreen">
          <div
            className=" panel-block has-background-grey-darker has-text-white-ter m-b-md"
            style={{ borderRadius: "4px" }}
          >
            <span className="control has-text-centered">
              <div className="columns is-mobile is-multiline">
                <div className="column is-half-semimobile">
                  <div className="field">
                    <div className="control has-text-centered">
                      <p className="field-value is-size-4 has-text-weight-bold  p-t-none">
                        {users.length}
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Registered
                    </label>
                  </div>
                </div>
                <div className="column is-half-semimobile">
                  <div className="field">
                    <div className="control has-text-centered">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        {
                          users.filter(
                            user => !user.isVerified && !user.isRejected,
                          ).length
                        }
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      For Review
                    </label>
                  </div>
                </div>
                <div className="column is-half-semimobile">
                  <div className="field">
                    <div className="control has-text-centered">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        {users.filter(user => user.isVerified).length}
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Verified
                    </label>
                  </div>
                </div>
                <div className="column is-half-semimobile">
                  <div className="field">
                    <div className="control has-text-centered">
                      <p className="field-value is-size-4 has-text-weight-bold p-t-none">
                        {users.filter(user => user.isRejected).length}
                      </p>
                    </div>
                    <label htmlFor="" className="label has-text-white-ter">
                      Rejected
                    </label>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <div className="panel">
            <p className="panel-heading">Info</p>

            <div className="panel-block">
              <span className="control control-centered">
                <div className="columns ">
                  <div className="column">
                    <div className="field fill-vertically">
                      <label htmlFor="" className="label nowrap">
                        Points Balance
                        <a
                          className="far fa-question-circle m-l-xs is-size-6 has-text-grey"
                          alt="points details"
                          onClick={() => {
                            setPointsModalOpen(true);
                          }}
                          style={{ width: "1em", height: "1em" }}
                        />
                      </label>
                      <div className="control">
                        <p className="field-value is-size-3 has-text-centered has-text-left-mobile">
                          <b>{points.points}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="column">
                    <div className="field fill-vertically">
                      <label htmlFor="" className="label">
                        Network Rank
                      </label>
                      <div className="control">
                        <p
                          className="field-value tooltip is-tooltip-right is-tooltip-multiline has-text-centered has-text-left-mobile"
                          data-tooltip={
                            "30 - Top 1%\n25-29 - Trail Blazing\n20-24 - Top Performer\n11-19 - Slow Burner\n0-10 - Tortoise League"
                          }
                          style={{
                            // display: "flex",
                            // alignItems: "center",
                            // flexDirection: "column",
                            paddingTop: "0.7rem"
                          }}
                        >
                          <img
                            className=""
                            src={getRankImg(points.points)}
                            style={{ width: "48px" }}
                            alt="rank"
                          />
                           <span>{getRank(points.points)}</span> 
                        </p>
                      </div>
                    </div>
                  </div> */}
                  <div className="column">
                    <div className="field">
                      <label htmlFor="" className="label nowrap">
                        Time Left
                      </label>
                      <div className="control">
                        <p
                          className={`field-value nowrap ${timeLeft !== null &&
                            timeLeft <= MS_IN_DAY &&
                            "has-text-danger"}`}
                          style={{
                            paddingTop: "1.6rem",
                          }}
                        >
                          <Countdown msTotal={timeLeft} />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="column">
                    <div className="field fill-vertically">
                      <label htmlFor="" className="label nowrap">
                        Date Joined
                      </label>
                      <div className="control">
                        <p
                          className="field-value"
                          style={{
                            paddingTop: "1.6rem",
                          }}
                        >
                          {signupDate}
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* </div>
            <div className="panel-block"> */}
                  <div className="column ">
                    <div className="field fill-vertically">
                      <label htmlFor="" className="label">
                        Status
                      </label>
                      <div className="control has-text-left">
                        <div className="field-value">
                          <span
                            className={`${
                              verifier ? "has-text-success" : "has-text-danger"
                            }`}
                          >
                            {verifier ? (
                              <span className="flex-col-center">
                                Verified by
                                <Avatar
                                  id={verifier.id}
                                  className="image-userlist avatar-centered"
                                />
                                {verifier.name}
                              </span>
                            ) : (
                              <div
                                style={{
                                  paddingTop: "1.3rem",
                                }}
                              >
                                Not verified
                              </div>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>

            <div className="panel-block ">
              <div className="control">
                <div className="field">
                  <label htmlFor="" className="label">
                    Points Summary
                  </label>

                  <div className="field-value">
                    <div className="columns is-mobile">
                      {getStatus(points) === "active" && (
                        <div
                          className="column is-narrow p-r-none"
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                            paddingBottom: "2.8rem",
                          }}
                        >
                          <span
                            className="tooltip"
                            data-tooltip="Your points in the current round"
                            style={{ fontSize: "1.5rem " }}
                          >
                            <b>{getCurrentIterPoints(points)}</b>
                          </span>
                        </div>
                      )}
                      <div className="column p-t-xs">
                        <p className="is-size-6 p-b-sm">
                          {/* <span className="is-size-3">
                            <b>{points.points}</b>
                          </span>
                          <br /> */}
                          {getStatus(points) === "active" && (
                            <Fragment>
                              You are just{" "}
                              {MAX_INVITEES_PER_ITERATION[
                                getIteration(points)
                              ] -
                                points[
                                  `iteration_${getIteration(points)}_invitees`
                                ].length}{" "}
                              contact verifications away from your goal!
                            </Fragment>
                          )}
                        </p>
                        <span className="use-bootstrap">
                          <ProgressBar
                            className=""
                            style={{ height: "1.4rem", marginBottom: "1rem" }}
                          >
                            <ProgressBar
                              variant="success"
                              now={
                                getStatus(points) === "active"
                                  ? (points.points / TOTAL_POINTS) * 100
                                  : 100
                              }
                              key={1}
                            />
                            <ProgressBar
                              animated
                              variant="warning"
                              now={
                                getStatus(points) === "active"
                                  ? ((MAX_INVITEES_PER_ITERATION[
                                      getIteration(points)
                                    ] *
                                      POINTS_PER_INVITEE -
                                      getCurrentIterPoints(points)) /
                                      TOTAL_POINTS) *
                                    100
                                  : 0
                              }
                              key={2}
                            />
                          </ProgressBar>
                          <div
                            style={{ display: "flex", alignItems: "baseline" }}
                          >
                            <ProgressBar
                              style={{
                                height: "0.8rem",
                                width: "0.8rem",
                                marginBottom: "0",
                              }}
                              variant="success"
                              now={100}
                            />
                            &nbsp;
                            {getStatus(points) === "active"
                              ? "Earned"
                              : "Total points earned"}
                            &nbsp;&nbsp;&nbsp;
                            {getStatus(points) === "active" && (
                              <Fragment>
                                <ProgressBar
                                  animated
                                  style={{
                                    height: "0.8rem",
                                    width: "0.8rem",
                                    marginBottom: "0",
                                  }}
                                  variant="warning"
                                  now={100}
                                />
                                &nbsp;Current&nbsp;&nbsp;&nbsp;
                                <ProgressBar
                                  style={{
                                    height: "0.8rem",
                                    width: "0.8rem",
                                    marginBottom: "0",
                                  }}
                                  now={0}
                                />
                                &nbsp;Future
                              </Fragment>
                            )}
                          </div>
                        </span>
                      </div>
                    </div>
                    {/* <p className="is-size-6">
                      <b>600</b> points out of <b>1000</b>
                    </p> */}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="panel-block p-t-none">
              <div className="control">
                <div className="columns ">
                  <div className="column" />
                  <div className="column is-narrow">
                    <div className="field">
                      <label htmlFor="" className="label has-text-right">
                        Time Left
                      </label>
                      <div className="control">
                        <p className="field-value has-text-right">
                          2D : 14H : 5M
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="panel-block p-t-md">
              <div className="control">
                <div className="field">
                  <label htmlFor="" className="label m-b-none">
                    Network Rank
                  </label>
                  <div className="columns">
                    <div className="column">
                      <div className="control">
                        <RankImg
                          img={rank5}
                          title="Snooze Mode"
                          num={5}
                          points={points}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="control">
                        <RankImg
                          img={rank4}
                          title="Tortoise"
                          num={4}
                          points={points}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="control">
                        <RankImg
                          img={rank3}
                          title="Trail Blazer"
                          num={3}
                          points={points}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="control">
                        <RankImg
                          img={rank2}
                          title="High Performance"
                          num={2}
                          points={points}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="control">
                        <RankImg
                          img={rank1}
                          title="Top 1%"
                          num={1}
                          points={points}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <p className="is-size-6"> */}
          </div>
          <div className="panel">
            <p className="panel-heading">
              Your first steps on OCCASIO Launch Base
            </p>

            <div className="panel-block">
              <span className="control">
                <iframe
                  width="100%"
                  // height="315"
                  src="https://www.youtube.com/embed/rEZjLC2Va4M?rel=0"
                  frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  style={{ height: "315px" }}
                />
                <div>
                  <img
                    className="m-t-md"
                    src={steps}
                    style={{ width: "100%" }}
                  />
                </div>
              </span>
            </div>
          </div>
          <div className="panel">
            <p className="panel-heading" id="spread">
              Grow your network
            </p>

            <div className="panel-block">
              <span className="control">
                <div className="field">
                  <div className="field">
                    <label htmlFor="" className="label has-text-weight-normal">
                      Share your unique code
                    </label>
                    <div className="field has-addons is-marginless">
                      <div
                        id="ref-url-div"
                        className="control is-expanded"
                        data-tooltip="Copied!"
                      >
                        <input
                          className="input"
                          // / before ? is required on static page server. otherwise queryString will be dropped due to redirect. https://stackoverflow.com/questions/20751301/how-can-i-get-query-strings-in-my-amazon-s3-static-website
                          id="ref-url"
                          value={`${location.origin}${withPrefix("/ref")}/?u=${
                            currentUser.uid
                          }`}
                          readOnly
                        />
                      </div>
                      <div className="control">
                        <a
                          className="button is-success"
                          onClick={() => {
                            document.getElementById("ref-url").select();
                            document.execCommand("copy");

                            const urlDiv = document.getElementById(
                              "ref-url-div",
                            );
                            urlDiv.classList.add(
                              "tooltip",
                              "is-tooltip-active",
                            );
                            setTimeout(() => {
                              urlDiv.classList.remove(
                                "tooltip",
                                "is-tooltip-active",
                              );
                            }, 3000);
                          }}
                        >
                          <span className="icon">
                            <i className="far fa-copy" />
                          </span>
                          <span>Copy</span>
                        </a>
                      </div>
                    </div>

                    <div className="field-value m-t-sm">
                      {/* <button
                        className="button is-success"
                        type="button"
                        onClick={() => {
                          setInviteTemplatesCb({
                            ...inviteTemplatesCb,
                            submit: () => {
                              setInviteTemplatesOpen(false);
                            }
                          });
                          setInviteTemplatesOpen(true);
                        }}
                      >
                        Show invite text examples
                      </button> */}
                      <div className="">
                        <div className="has-text-weight-normal">
                          Via email and social media for the best results and
                          earn points
                        </div>
                        <div className=" social">
                          <a
                            title="email"
                            href={`mailto:?subject=I have just signed onto OCCASIO Launch Base. You should join me!&body=${getEmailShareText(
                              location.origin,
                              currentUser.uid,
                              true,
                            )}`}
                            target="_blank"
                          >
                            <span
                              className="far fa-envelope"
                              alt="email"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                          <a
                            title="linkedin"
                            href={`https://www.linkedin.com/sharing/share-offsite/?url=${origin}${withPrefix(
                              "/ref",
                            )}/?u=${currentUser.uid}`}
                            target="_blank"
                          >
                            <span
                              className="fab fa-linkedin-in"
                              alt="linkedin"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                          <a
                            title="facebook"
                            // 500 chars limit on quote
                            href={`https://www.facebook.com/sharer/sharer.php?u=${origin}${withPrefix(
                              "/ref",
                            )}/?u=${
                              currentUser.uid
                            }&hashtag=${convertHashtagsToURLFormat(
                              ["OCCASIO"],
                              true,
                            )}&quote=${getFbShareText(
                              location.origin,
                              currentUser.uid,
                              false,
                            )}`}
                            target="_blank"
                          >
                            <span
                              className="fab fa-facebook-f"
                              alt="facebook"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                          {/* <a
                            title="skype"
                            href={`https://web.skype.com/share?url=${origin}${withPrefix(
                              "/ref",
                            )}/?u=${currentUser.uid}&text=${getSkypeShareText(
                              location.origin,
                              currentUser.uid,
                            )}`}
                          >
                            <span
                              className="fab fa-skype"
                              alt="skype"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a> */}
                          <a
                            title="twitter"
                            href={`http://twitter.com/intent/tweet?text=${getTwtrShareText(
                              location.origin,
                              currentUser.uid,
                            )}&hashtags=${convertHashtagsToURLFormat([
                              "onOCCASIO",
                              "onOCCASIOInvite",
                              "onOCCASIOReferral",
                              "Africa",
                              "Investing",
                              "Jobs",
                            ])}`}
                            target="_blank"
                          >
                            <span
                              className="fab fa-twitter"
                              alt="twitter"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                          <a
                            title="whatsapp"
                            href={`https://api.whatsapp.com/send?text=${getSkypeShareText(
                              location.origin,
                              currentUser.uid,
                            )}&hashtags=${convertHashtagsToURLFormat([
                              "onOCCASIO",
                              "onOCCASIOInvite",
                              "onOCCASIOReferral",
                              "Africa",
                              "Investing",
                              "Jobs",
                            ])}`}
                            target="_blank"
                          >
                            <span
                              className="fab fa-whatsapp"
                              alt="whatsapp"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                          <a
                            title="show text"
                            onClick={() => {
                              setInviteTemplatesOpen(true);
                            }}
                          >
                            <span
                              className="far fa-comment-dots"
                              alt="show text"
                              style={{ width: "1em", height: "1em" }}
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                    {/* <p className="field-value">
                      <Link to="/ref-users">
                        {refUsers.totalCount} users registered,{" "}
                        {refUsers.notVerifiedCount} not verified
                      </Link>
                    </p> */}
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
        <div className="column is-6-desktop is-6-widescreen">
          <div className="panel">
            <p className="panel-heading">Latest updates from the blog</p>

            <div className="panel-block">
              <span className="control m-b-sm">
                <BlogLatest />
                {/* <BlogCarousel settings={sliderSettings} showLogo={false} /> */}
              </span>
            </div>
          </div>
          {/* <div className="panel">
            <p className="panel-heading">Magic panel</p>
            <div className="panel-block">
              <div className="field">
                <p>
                  Changes are temporary and will disappear after page refresh.
                </p>
                <p>
                  Your real invitees aren't shown, for testing purposes you
                  start from scratch.
                </p>
                <p>
                  In case of wrong calculations/bugs, click{" "}
                  <button
                    className=""
                    onClick={() => {
                      copyToClipboard(
                        JSON.stringify({ ...points, currentDate }, null, 4)
                      );
                    }}
                  >
                    here
                  </button>{" "}
                  to copy debug info into clipboard and then send it to me.
                </p>
              </div>
            </div>
            <div className="panel-block">
              <div className="field">
                <label htmlFor="" className="label">
                  Invetees
                </label>
                <div className="control">
                  <button
                    type="button"
                    onClick={() => {
                      const newUser = {
                        uid: Math.random(),
                        name: `${getRandomArrayElem([
                          "John",
                          "Jane",
                          "Tom",
                          "Kate",
                          "Brian",
                          "Rachel",
                          "Jack",
                          "Amelia",
                          "James",
                          "Emily"
                        ])} ${getRandomArrayElem([
                          "Doe",
                          "Smith",
                          "Turner",
                          "Wilson",
                          "Johnson",
                          "Thomas",
                          "Garcia",
                          "Lee",
                          "Allen",
                          "King",
                          "Tailor"
                        ])}`,
                        signUpDate: formatDate(currentDate),
                        signUpDateRaw: currentDate,
                        isVerified: false
                      };
                      users.push(newUser);
                      users.sort(
                        (a, b) =>
                          b.signUpDateRaw.getTime() - a.signUpDateRaw.getTime()
                      );
                      setUsers([...users]);
                    }}
                    className="button is-success "
                  >
                    Add new invitee
                  </button>
                </div>
              </div>
            </div>
            <div className="panel-block">
              <div className="field">
                <label htmlFor="" className="label">
                  Current date
                </label>
                <div className="control">
                  <p>{formatDate(currentDate)}</p>
                  <button
                    type="button"
                    onClick={() => {
                      setCurrentDate(
                        new Date(currentDate.setDate(currentDate.getDate() + 1))
                      );
                    }}
                    className="button is-success m-t-md"
                  >
                    Next day
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          <div className="panel">
            <span
              id="userlist"
              // style is for scroll to take into account navbar height
              style={{
                display: "block",
                position: "relative",
                top: "-67px",
                visibility: "hidden",
              }}
            />
            <p className="panel-heading">Your Connections</p>

            <div className="panel-block">
              <span className="control">
                <div className="">
                  OCCASIO is a trusted network. Please only verify people you
                  know to lock-in your points. Accounts that breach our terms
                  will be suspended without notice. See our{" "}
                  <Link className="" to="/terms">
                    Terms&nbsp;&&nbsp;Conditions
                  </Link>
                  .
                </div>

                {users.length === 0 ? (
                  <p className="m-b-sm m-t-md">
                    <b>
                      No one registered with your link yet.{" "}
                      <a href="#spread">Grow your network</a>!
                    </b>
                  </p>
                ) : (
                  ""
                )}
                {users.length > 0 ? (
                  <Tabs
                    className="tabs is-centered is-boxed is-toggle is-fullwidth m-b-sm m-t-lg"
                    selectedTabClassName="is-active"
                  >
                    <TabList className="m-b-mdd">
                      <Tab>
                        <a>
                          <span>For Review</span>
                          <span className="tag is-light m-l-sm">
                            {
                              users.filter(
                                user => !user.isVerified && !user.isRejected,
                              ).length
                            }
                          </span>
                        </a>
                      </Tab>
                      <Tab>
                        <a>
                          <span>Verified</span>
                          <span className="tag is-light m-l-sm">
                            {users.filter(user => user.isVerified).length}
                          </span>
                        </a>
                      </Tab>
                      <Tab>
                        <a>
                          <span>Rejected</span>
                          <span className="tag is-light m-l-sm">
                            {users.filter(user => user.isRejected).length}
                          </span>
                        </a>
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <UserList
                        users={users}
                        currentUserUid={currentUser.uid}
                        verify={verify}
                        reject={reject}
                      />
                    </TabPanel>
                    <TabPanel>
                      <VerifiedUserList users={users} />
                    </TabPanel>
                    <TabPanel>
                      <RejectedUserList users={users} />
                    </TabPanel>
                  </Tabs>
                ) : (
                  ""
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
      <Modal
        idPrefix="invite"
        title="Shareable invitation text for your convenience"
        isOpen={inviteTemplatesOpen}
        cb={inviteTemplatesCb}
        infoOnly
      >
        <span>
          <b>Twitter</b>
          <br />
          <a
            className="has-text-primary is-italic has-tooltip-bottom"
            id="share-text-twtr-btn"
            data-tooltip="Copied!"
            onClick={() => {
              copyToClipboard(
                getTwtrShareText(location.origin, currentUser.uid),
              );

              const urlDiv = document.getElementById("share-text-twtr-btn");
              urlDiv.classList.add("tooltip", "is-tooltip-active");
              setTimeout(() => {
                urlDiv.classList.remove("tooltip", "is-tooltip-active");
              }, 3000);
            }}
          >
            Click me to copy
          </a>
          <br />
          <br />
          {getTwtrShareText(location.origin, currentUser.uid)}
          <br />
          <br />
          <b>Whatsapp, Skype, Viber</b>
          <br />
          <a
            className="has-text-primary is-italic has-tooltip-bottom"
            id="share-text-skype-btn"
            data-tooltip="Copied!"
            onClick={() => {
              copyToClipboard(
                getSkypeShareText(location.origin, currentUser.uid),
              );

              const urlDiv = document.getElementById("share-text-skype-btn");
              urlDiv.classList.add("tooltip", "is-tooltip-active");
              setTimeout(() => {
                urlDiv.classList.remove("tooltip", "is-tooltip-active");
              }, 3000);
            }}
          >
            Click me to copy
          </a>
          <br />
          <br />
          {getSkypeShareText(location.origin, currentUser.uid)}
          <br />
          <br />
          <b>Linkedin, Facebook</b>
          <br />
          <a
            className="has-text-primary is-italic has-tooltip-bottom"
            id="share-text-fb-btn"
            data-tooltip="Copied!"
            onClick={() => {
              copyToClipboard(getFbShareText(location.origin, currentUser.uid));

              const urlDiv = document.getElementById("share-text-fb-btn");
              urlDiv.classList.add("tooltip", "is-tooltip-active");
              setTimeout(() => {
                urlDiv.classList.remove("tooltip", "is-tooltip-active");
              }, 3000);
            }}
          >
            Click me to copy
          </a>
          <br />
          <br />
          {getFbShareText(location.origin, currentUser.uid)}
          <br />
          <br />
          <b>EMAIL</b>
          <br />
          <a
            className="has-text-primary is-italic has-tooltip-bottom"
            id="share-text-email-btn"
            data-tooltip="Copied!"
            onClick={() => {
              copyToClipboard(
                getEmailShareText(location.origin, currentUser.uid),
              );

              const urlDiv = document.getElementById("share-text-email-btn");
              urlDiv.classList.add("tooltip", "is-tooltip-active");
              setTimeout(() => {
                urlDiv.classList.remove("tooltip", "is-tooltip-active");
              }, 3000);
            }}
          >
            Click me to copy
          </a>
          <br />
          <br />
          Subject Line: I have just signed to OCCASIO Launch Base. Join me!
          <br />
          <br />
          {getEmailShareText(location.origin, currentUser.uid)}
          <br />
          <br />
        </span>
      </Modal>

      <Modal
        idPrefix="point-modal"
        title="Points details"
        isOpen={pointsModalOpen}
        cb={pointsModalCb}
        infoOnly
        additionalBtn={
          <div className="dropdown is-hoverable is-right is-down m-l-md">
            <div className="dropdown-trigger">
              <button
                className="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu4"
              >
                <span>Show variables</span>
                <span className="icon is-small">
                  <i className="fas fa-angle-down" aria-hidden="true" />
                </span>
              </button>
            </div>
            <div className="dropdown-menu" id="dropdown-menu4" role="menu">
              <div className="dropdown-content ">
                <div className="dropdown-item">
                  <p>{ITERATIONS_COUNT} rounds total</p>
                  <p>{DAYS_PER_ITERATION} days per round</p>
                  <p>{POINTS_PER_INVITEE} points per successful verification</p>
                </div>
              </div>
            </div>
          </div>
        }
      >
        <div className="columns">
          <div className="column">
            <span className="has-text-grey has-text-weight-bold">
              <span className="">Signup</span>
            </span>
            <br />
            <span className="">
              <span className="is-size-4 has-text-weight-bold">
                {POINTS_FOR_SIGNUP}
              </span>{" "}
              points
            </span>
            <br />
            <br />
            {getIterationLabel(
              1,
              points.iteration_1_invitees,
              getIteration(points),
              getStatus(points),
            )}
            {getIterationLabel(
              2,
              points.iteration_2_invitees,
              getIteration(points),
              getStatus(points),
            )}
            {getIterationLabel(
              3,
              points.iteration_3_invitees,
              getIteration(points),
              getStatus(points),
            )}
            <span className="has-text-weight-bold">Total</span>
            <br />
            <span className="is-size-4 has-text-weight-bold">
              {points.points}
            </span>{" "}
            points
          </div>
          {/* <div
            className="column is-narrow has-text-right has-text-grey is-size-6"
            style={{
              alignSelf: "flex-end"
            }}
          >
            <p>3 iterations total</p>
            <p>20 days per iteration</p>
            <p>20 users max per iteration</p>
            <p>20 points per user</p>
          </div> */}
        </div>
      </Modal>
    </div>
  );
};

const RefUsers = ({ location }) => {
  return <PlainPage Content={Content(location)} isPrivate />;
};

export default RefUsers;
